// import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from "./system/lang/lang.js";
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import GullKit from "./plugins/gull.kit.js";
import Breadcumb from "./components/breadcumb.vue";
import firebase from "firebase/app";
import { firebaseSettings } from "./data/config.js";
import InstantSearch from 'vue-instantsearch';
import { setLanguage } from "./system/api/api";

Vue.component('VueFontawesome', require('vue-fontawesome-icon/VueFontawesome.vue').default);
Vue.component("breadcumb", Breadcumb);

Vue.use(InstantSearch);
Vue.use(GullKit);
// Vuelidate is already registered inside GullKit

firebase.initializeApp(firebaseSettings);



Vue.config.productionTip = false;

new Vue({
  data() {
    return {
      isLoading: false,
      loggedIn: !!localStorage.getItem('currencyToken'),
      needRiskLevel: false,
      cannotUpgrade: true,
      userInfo: {
        premium_member:'',
        invest: 0,
        user_group_id: 0,
        point3: '',
        rank: {
          rank_name_en: ''
        },
        package: {
          price: 0,
        }
      },
      bankInfo: {},
      cryptoInfo: {},
      selectedWallet: '',
      currentAddress: '',
      username: '',
      memberList: [],
      country_code: '',
      countryOptions: [],
      countryDepositOptions: [],
      teamList: [],
      newsList: [],
      latestNews: [],
      packageList: [],
      bannerList: [],
      userPackages: [],
      assetInfo: {
        static_bonus: 0,
        special_bonus: 0,
        dynamic_bonus: 0,
        level_bonus: 0,
      },
      variant: 'success',
      modal: {
        title: "",
        msg: "",
        action: false,
        actionType: '',
        error: false,
      },
      defaultCountry: {},
      globalSetting: null,
      blockWithdraw: false,
      admin_replied: 0,
      selectedVoucher: {},
      selectedList: [],
      cartItems: JSON.parse(localStorage.getItem('shopCart') || '[]'),
      buyNowItem: null,
      showedMsg: false,
    }
  },
  computed: {
    cartCount() {
      return this.cartItems.reduce((s, i) => s + i.qty, 0);
    },
  },
  watch: {
    "$i18n.locale": "setLang"
  },
  methods: {
    changeLan(lan) {
      if (lan == 'zh' || lan == 'en' || lan == 'my' || lan == 'zhHant' || lan == 'ja' || lan == 'ko' || lan == 'vn') {
        localStorage.setItem('lan', lan);
        this.$i18n.locale = lan;

      } else {
        this.$root.makeToast("warning", this.$t('coming_soon'));
      }
    },
    makeToast(variant = null, msg) {
      this.$bvToast.toast(msg, {
        // // title: ` ${variant || "default"}`,
        variant: variant,
        solid: true,
      });
    },
    setLang() {
      let formData = new FormData();
      formData.append('language', this.$i18n.locale == 'en' ? 'en' : 'cn');
      setLanguage(formData);
      // var self = this;
      // result.then(function () {

      // });
    },
    checkKYC() {
      if (this.userInfo.check_kyc.can_withdraw == 'approved') {
        this.$bvModal.show('withdraw');

      } else {
        this.modal = {
          title: this.$t('kyc'),
          msg: this.$t('kyc_hint'),
          action: false,
          error: true,
        };
        this.$bvModal.show('modal-errorMsg');

      }
    },
    addToCart(product, qty = 1) {
      const existing = this.cartItems.find(i => i.id === product.id);
      if (existing) {
        existing.qty += qty;
      } else {
        this.cartItems.push({ id: product.id, name: product.name, price: product.price, image: product.image, descShort: product.descShort, qty });
      }
      localStorage.setItem('shopCart', JSON.stringify(this.cartItems));
    },
    removeFromCart(id) {
      this.cartItems = this.cartItems.filter(i => i.id !== id);
      localStorage.setItem('shopCart', JSON.stringify(this.cartItems));
    },
    updateCartQty(id, qty) {
      const item = this.cartItems.find(i => i.id === id);
      if (!item) return;
      if (qty <= 0) {
        this.cartItems = this.cartItems.filter(i => i.id !== id);
      } else {
        item.qty = qty;
      }
      localStorage.setItem('shopCart', JSON.stringify(this.cartItems));
    },
    clearErrorMsg() {
      this.$root.modal = {
        title: "",
        msg: "",
        action: false,
        error: false,
      };

    },
    updatePb() {
      var heighest = 0;
      var bottom = document.getElementsByClassName('withdraw-hint');
      var mainContent = document.getElementsByClassName('main-content');
      if (mainContent) {
        mainContent = mainContent[0];
        if (bottom) {
          for (let i = 0; i < bottom.length; i++) {
            if (bottom[i].offsetHeight > heighest) {
              heighest = bottom[i].offsetHeight;
              console.log(heighest);

            }
          }

        }
        if (mainContent)
          mainContent.setAttribute('style', 'padding-bottom:' + (heighest + 100) + 'px !important');


      }



    }
  },
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
